import React, { Component, ReactNode } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { setAppPage } from '../../../redux/actions/appPage.actions';
import { setPickTourPage } from '../../../redux/actions/pickTourPage.actions';
import { APP_PAGE_ORDER_LIST, PICK_TOUR_PAGE_PICK_TOUR } from '../../../constants';
import ErrorFallback from '../../shared/ErrorFallback';

interface ErrorBoundaryState {
  hasError: boolean;
}

interface DispatchProps {
  dispatch: Dispatch;
}

interface OwnProps {
  children: ReactNode;
}

type Props = DispatchProps & OwnProps;

class PickTourErrorBoundary extends Component<Props, ErrorBoundaryState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('PickTourErrorBoundary caught error:', error, errorInfo);
  }

  returnToOrders = () => {
    const { dispatch } = this.props;

    this.setState({ hasError: false });
    dispatch(setAppPage({ name: APP_PAGE_ORDER_LIST }));
    dispatch(setPickTourPage({ name: PICK_TOUR_PAGE_PICK_TOUR }));
  };

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <ErrorFallback onReturnClick={this.returnToOrders} />;
    }

    return children;
  }
}

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  dispatch,
});

export default connect(null, mapDispatchToProps)(PickTourErrorBoundary);
